export interface IPaymentTerms {
  m1PaymentPercentage: string;
  m2PaymentPercentage: string;
  m3PaymentPercentage: string;
  upcomingClawbackDate: Date;
  preventDesignatedHoldbackInvoice: boolean;
}

export class PaymentTerms implements IPaymentTerms {
  m1PaymentPercentage: string;
  m2PaymentPercentage: string;
  m3PaymentPercentage: string;
  upcomingClawbackDate: Date;
  preventDesignatedHoldbackInvoice: boolean;
}
